export enum Path {
  ERROR = 'errore',
  HOME = '',
  LOGIN = 'login',
  LOGOUT = 'logout',
  MANUTENZIONE = 'manutenzione',
  RECUPERO_PASSWORD = 'recupero-password',
  CAMBIO_PASSWORD = 'cambio-password',
  REPORT_RETE_TERZA = 'report-rete-terza',
  //Path utilizzato del router per visualizzare il componente
  REPORT_RETI_LOCKER = 'report-reti-locker',
  POINT_POST = 'punto-poste',
  POINT_POST_LOCKER = 'punto-poste-locker',
  RENDICONTAZIONE = 'rendicontazione',
  ANAGRAPHIC = 'anagrafica',
  ANAGRAPHIC_MANAGEMENT = 'gestione-anagrafica',
  DOCUMENTS = 'documenti',
  INTERFACE_MONITORING = 'monitoraggio-interfacce',
  ANAGRAPHIC_MONITORAGGIO = 'monitoraggio',
  DETAIL = 'dettaglio',
  HISTORY = 'storico',
  OPERATIONS = 'operazioni',
  OPERATIONS_LOCKER = 'operazioni-locker',
  ANAGRAPHIC_NEW_OPERATION = 'nuova-operazione',
  INTERFACE_HISTORY = 'storico-interfacce',
  COMUNICATION = 'comunicazione',
  HEADER = 'header',
  NOTICEBOARD = 'bacheca',
  RECIPIENTS = 'destinatari',
  INSERT = 'inserimento',
  UTILITY = 'utility',
  BOXLESS = 'boxless',
  ATTIVAZIONE_MASSIVA = 'attivazione-massiva',
  COMPENSI = 'compensi',
  REPORT_PUNTO_POSTE = 'report-punto-poste',
  POINTS_MANAGEMENT = 'gestione-punti',
  EDIT_RETE_TERZA = 'modifica-rete-terza',
  DELIVERY_STUCTURE = 'struttura-recapito',
  SEARCH_LDV = 'cerca-ldv',
  SEARCH_FRAZIONARIO = 'cerca-frazionario',
  POINTS_MANAGEMENT_DETAIL = 'dettaglio-punto-poste',
  POINTS_MANAGEMENT_DETAIL_LOCKER = 'dettaglio-punto-poste-locker',
  USER_MANAGEMENT = 'gestione-utenze',
  CREATE = 'creazione',
  EXTRACTION_MIG2= 'extraction-mig2',
  REPORT_GIACENZA = 'report-giacenza',
  REPORT_GIACENZA_LOCKER = 'report-giacenza-locker',
  MASSIVE_UPLOAD = 'caricamento-massivo',
  RECOVERY = 'recovery',
  MASSIVE_ASSOCIATION = 'associazione-massiva',
  MATERIAL_CATALOGUE = 'catalogo-materiale',
  CLUSTER = 'cluster',
  //CONFIGURAZIONE_CLUSTER = 'configurazione-cluster',
  FORZA_ATTIVAZIONE_SERVIZI_MASSIVA = 'forza-attivazione-servizi-massiva',
  UPLOAD_MASSIVO_FERIE='upload-massivo-ferie',
  ORDER_RULES = 'regole-ordine',
  ORDER_CREATE = 'creazione-ordine',
  ORDERS_HISTORY = 'storico-ordini',
  SUPPLY_CONFIGURATION = 'configurazione-approvvigionamento',
  RISULTATO = 'risultato',
  FRAZIONARIO = 'frazionario',
  PIN_RECOVERY = 'recupero-pin',
  PREATTIVAZIONE_MASSIVA = 'pre-attivazione-massiva',
  PREATTIVAZIONE = 'pre-attivazione',
  CARICAMENTO_MASSIVO_UTENZE = 'caricamento-massivo-utenze'
}
